import { useState, useEffect, useRef, Fragment, memo, useMemo } from "react";
import style from "./../index.module.scss";
import styleUi from "./Contact.module.scss";
import allStyle from "./../../comm/global/all.module.scss";
import { v4 } from "uuid";
import styled from "styled-components";
import { CSSTransition } from 'react-transition-group';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import * as YStyled from "../../Styleds";
import FriendInfo from "../../comm/global/components/FriendInfo";
import LogItem from "../../comm/global/components/LogItem";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
const maxLen = 250;
const Contact = ({ setModalType, arg, addModalType }) => {
    const [inProp, setInProp] = useState(false);
    const [done, set_done] = useState(false);
    const [msg, set_msg] = useState("");
    const [errMsg, set_errMsg] = useState("");
    const [mail, set_mail] = useState("");
    useEffect(() => {
        setInProp(true);
        document.title = "聯絡我們";
    }, [])

    return (
        <div className={style.modal}>
            <CSSTransition in={inProp} timeout={{
                appear: 0,
                enter: 300,
                exit: 0,
            }} classNames={{
                enterActive: style.SwipePageEnterActive,
                enterDone: style.SwipePageEnterDone,
                exitActive: style.SwipePageExit,
                exitDone: style.SwipePageExitActive
            }}
                onExited={async () => {
                    await new Promise(resolve => requestAnimationFrame(resolve));
                    setModalType(prev => prev.filter(v => v.cls !== "Contact"))
                }}
            >
                <div className={`${style.SwipePage} ${style.Page}`} >
                    <div className={styleUi.app}>
                        <div className={styleUi.headerBar}>
                            <img src="./assets/ui/back.png" onClick={e => { setInProp(false) }} />
                        </div>
                        <div className={styleUi.view}>
                            <img src="./assets/ui/contact.png" style={{ alignSelf: "flex-end", marginTop: "2rem" }} />
                            {done === false ?
                                <>
                                    <YStyled.Span size={22} fontWeight={600} style={{ alignSelf: "flex-start", marginTop: "1rem" }}>聯絡我們</YStyled.Span>
                                    <YStyled.Label style={{ width: "100%", marginTop: "1rem" }}>
                                        <YStyled.Col>
                                            <YStyled.Span size={13}>電子信箱</YStyled.Span>
                                            <YStyled.Input size={17} placeholder="Email" onChange={e => {
                                                set_mail(e.target.value);
                                            }} />
                                        </YStyled.Col>
                                    </YStyled.Label>
                                    <YStyled.Label style={{ width: "100%", marginTop: "1rem" }}>
                                        <YStyled.Col>
                                            <YStyled.Span size={13}>留言內容</YStyled.Span>
                                            <textarea placeholder="文字..." maxLength={maxLen} className={styleUi.inputArea} value={msg} onChange={e => {
                                                set_msg(e.target.value);
                                            }}></textarea>
                                            <YStyled.Span size={12} color="#CCCCCC" style={{ position: "absolute", bottom: "4px", right: "4px" }}>{`${msg.length}/${maxLen}`}</YStyled.Span>
                                        </YStyled.Col>
                                    </YStyled.Label>
                                    <YStyled.Span size={13} color="#990000" fontWeight={400} style={{ alignSelf: "flex-start", marginTop: "1rem" }}>{errMsg}</YStyled.Span>
                                    <YStyled.BTN3 disabled={!(msg.length > 0&&mail.length > 0)} normalBg="#000" normalColor="white" disableBg="#00000088" disableColor="#FFF" style={{ width: "100%", padding: ".8rem", borderWidth: "0px", borderRadius: "10px", marginTop: "1.5rem" }} onClick={e => {
                                        console.log("(/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(mail))", mail, (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(mail)))
                                        if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(mail)) {
                                            set_done(true);
                                        }
                                        else {
                                            set_errMsg("您輸入的信箱格式錯誤")
                                        }
                                    }}>
                                        <YStyled.Span size={17} >傳送</YStyled.Span>
                                    </YStyled.BTN3>
                                </>
                                :
                                <>
                                    <YStyled.Span size={22}  style={{ alignSelf: "flex-start", marginTop: "1rem" }}>謝謝您的聯繫</YStyled.Span>
                                    <YStyled.Span size={13} fontWeight={400} style={{ alignSelf: "flex-start", marginTop: "1rem" }}>我們已收到您的留言，並將盡快回覆。</YStyled.Span>
                                </>
                            }
                        </div>
                    </div>
                </div>
            </CSSTransition>
        </div>
    );
}

export default memo(Contact);